/* eslint-disable @typescript-eslint/no-explicit-any */
export const createPromiseResolver = () => {
	let resolve: () => void;

	const promise = new Promise<void>(r => {
		resolve = r;
	});
	// we are overriding the resolve! here because the new Promise will definitely assign it
	return { resolve: resolve!, promise };
};

export let win: { [name: string]: any };

if (typeof window !== 'undefined') {
	win = window;
} else if (typeof global !== 'undefined') {
	win = global;
} else if (typeof self !== 'undefined') {
	win = self;
} else {
	win = {};
}

// TODO: For better type safety, the manifest shape for each plugin should be strongly typed and thus
// the name argument becomes a sub-key of this manifest collection and the return type becomes a mapped
// type of the manifest shape keyed on the given name
export function getManifest(name?: string): any {
	const n = name ?? 'fox-seeourm';
	const manifestList = typeof window !== 'undefined' && Array.isArray((window as any)['manifest']) ? ((window as any)['manifest'] as Array<{ name: string }>) : [];
	const manifest = manifestList.find(m => m.name === n);
	return manifest ?? {};
}
